import { createBrowserRouter, Navigate } from 'react-router-dom';
import { paths } from './paths';
import Login from '../screens/auth/Login';
import AuthenticatedLayout from '../components/layout/AuthenticatedLayout';
import ProtectedRoute from './ProtectedRoute';
import ForgotPassword from '../screens/auth/ForgotPassword';
import ResetPassword from '../screens/auth/ResetPassword';
import Reviews from '../screens/Reviews';
import Profile from '../screens/Profile';
import Signup from '../screens/auth/Signup';
import Recycle from 'screens/Recycle';
import RecycleHistory from 'screens/RecycleHistory';
import Rewards from 'screens/Rewards';
import AppVersions from 'screens/AppVersions';
import BinGuidelines from 'screens/BinGuidelines';
import MaterialsCatalog from 'screens/MaterialsCatalog';
import OrgAdmins from 'screens/OrgAdmins';
import AnnotatorAccess from 'screens/AnnotatorAccess';

export const router = createBrowserRouter([
  {
    path: paths.login,
    element: <Login />,
  },
  {
    path: paths.signup,
    element: <Signup />,
  },
  {
    path: paths.forgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: paths.resetPassword,
    element: <ResetPassword />,
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        path: paths.home,
        element: <AuthenticatedLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={paths.recycle} replace />,
          },
          {
            path: paths.reviews,
            element: <Reviews />,
          },
          {
            path: paths.appVersions,
            element: <AppVersions />,
          },
          {
            path: paths.adminBinGuidelines,
            element: <BinGuidelines />,
          },
          {
            path: paths.adminMaterials,
            element: <MaterialsCatalog />,
          },
          {
            path: paths.adminOrgAdmins,
            element: <OrgAdmins />,
          },
          {
            path: paths.adminAnnotatorAccess,
            element: <AnnotatorAccess />,
          },
          {
            path: paths.recycle,
            element: <Recycle />,
          },
          {
            path: paths.rewards,
            element: <Rewards />,
          },
          {
            path: paths.profile,
            element: <Profile />,
          },
          {
            path: paths.history,
            element: <RecycleHistory />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={paths.recycle} replace />,
  },
]);
